export const outBoundInt = {
  airBoundId: '2VFhf8aec7d46bf',
  originLocationCode: 'ORY',
  destinationLocationCode: 'CUN',
  flights: [
    {
      id: 'ST2',
      bookingClass: 'Z',
      statusCode: 'TK'
    }
  ],
  duration: 39900,
  disruptionStatus: {
    originalFlights: [
      {
        id: 'ST1',
        bookingClass: 'Z',
        statusCode: 'UN',
        fareFamilyCode: 'JSMART'
      }
    ],
    departure: {
      locationCode: 'ORY',
      sameAirport: true,
      sameCity: true,
      sameDay: true,
      deltaTime: -172800
    },
    arrival: {
      locationCode: 'CUN',
      sameAirport: true,
      sameCity: true,
      sameDay: true,
      deltaTime: -172800
    },
    connection: {
      status: 'ok',
      delta: 0,
      sameViaPoint: true,
      deltaTime: 0
    },
    duration: 39900
  }
};

export const inBoundInt = {
  airBoundId: '2',
  originLocationCode: 'CUN',
  destinationLocationCode: 'ORY',
  flights: [
    {
      id: 'ST2',
      cabin: 'eco',
      bookingClass: 'N',
      statusCode: 'HK',
      arrivalDaysDifference: 1,
      fareFamilyCode: 'EBASIC'
    }
  ],
  duration: 35400
};

export const outBoundRtDom = {
  'airBoundId': '2VFhf7bb9187424',
  'originLocationCode': 'PTP',
  'destinationLocationCode': 'FDF',
  'flights': [
    {
      'id': 'ST3',
      'bookingClass': 'T',
      'statusCode': 'TK'
    }
  ],
  'duration': 2700,
  'disruptionStatus': {
    'boundStatus': 'disrupted',
    'originalFlights': [
      {
        'id': 'ST1',
        'bookingClass': 'L',
        'statusCode': 'UN'
      }
    ],
    'departure': {
      'locationCode': 'PTP',
      'sameAirport': true,
      'sameCity': true,
      'sameDay': true,
      'deltaTime': 14400
    },
    'arrival': {
      'locationCode': 'FDF',
      'sameAirport': true,
      'sameCity': true,
      'sameDay': true,
      'deltaTime': 14400
    },
    'connection': {
      'status': 'ok',
      'delta': 0,
      'sameViaPoint': true,
      'deltaTime': 0
    },
    'duration': 2700
  }
};

export const inBoundRtDom = {
  'airBoundId': '2VFhf74767015a5',
  'originLocationCode': 'FDF',
  'destinationLocationCode': 'PTP',
  'flights': [
    {
      'id': 'ST4',
      'bookingClass': 'R',
      'statusCode': 'TK'
    }
  ],
  'duration': 2700,
  'disruptionStatus': {
    'boundStatus': 'disrupted',
    'originalFlights': [
      {
        'id': 'ST2',
        'bookingClass': 'R',
        'statusCode': 'UN'
      }
    ],
    'departure': {
      'locationCode': 'FDF',
      'sameAirport': true,
      'sameCity': true,
      'sameDay': true,
      'deltaTime': 75600
    },
    'arrival': {
      'locationCode': 'PTP',
      'sameAirport': true,
      'sameCity': true,
      'sameDay': true,
      'deltaTime': 75600
    },
    'connection': {
      'status': 'ok',
      'delta': 0,
      'sameViaPoint': true,
      'deltaTime': 0
    },
    'duration': 2700
  }
};

export const inBoundRtDomNonDisrupt = {
  airBoundId: '2',
  originLocationCode: 'FDF',
  destinationLocationCode: 'PTP',
  flights: [
    {
      id: 'ST2',
      cabin: 'business',
      bookingClass: 'Z',
      statusCode: 'HK',
      fareFamilyCode: 'JSMART'
    }
  ],
  duration: 30900
};
